export default {"src":"/_next/static/media/progress.mono.73039fc6.svg","height":366,"width":366,"blurWidth":0,"blurHeight":0};